{#if showProfile}
  <div class="flood-risk-profile-blocker" transition:fade="{{delay: 250, duration: 300}}"></div>
{/if}
<div class="flood-risk-profile">
  <div 
    class="flood-risk-profile-mini-bar {riskProfile && riskProfile.AOI === 'IN' ? 'pointer' : ""} {showProfile ? "slide-up" : ""}" 
    on:click={toggleRiskProfile}
    bind:this={floodRiskProfileMiniBar}>
    {#if riskProfile && riskProfile.AOI === 'IN'}
      <div class="arrow-icons {showProfile ? 'reverse' : ''}">
        <img src={riskDetailIcon} alt="arrow" />
        <img src={riskDetailIcon} alt="arrow" />
      </div>
      <p class="bold">VIEW FLOOD RISK ({capitalize(riskProfile.Suburb)})
        {#if showProfileCount < 1}
          <span class="new-flood-risk"></span>
        {/if}
      </p>
    {:else}
      <p><span class="bold">Click</span> or <span class="bold">Search</span> the map to view suburb risk profile</p>
    {/if}
  </div>
  {#if showProfile}
    <div class="flood-risk-profile-content" transition:slide="{{delay: 250, duration: 300, easing: quintOut }}">
        {#if riskProfile.AOI === "OUT"}
          <div class="risk-profile-section">
            <strong style="color: red">
              Please enter a suburb within the Hawkesbury-Nepean floodplain. For other locations consult your local council about your flood risk or visit <a target="_blank" href="//www.ses.nsw.gov.au/disaster-tabs-header/flood">NSW SES flood information</a>.
            </strong>
          </div>
        {:else}
          <div class="risk-profile-section">
            {#if riskProfile.Postcode === null}
              <p>This suburb is not within the Hawkesbury-Nepean Valley. Check with your local council regarding your flood risk and visit <a target="_blank" href="//www.ses.nsw.gov.au/disaster-tabs-header/flood/">NSW SES flood</a> information.</p>
            {/if}
            {#if riskProfile.Risk_Profile___paragraph_1}
              <p class="first-para">{@html toTooltip(riskProfile.Risk_Profile___paragraph_1, riskProfile.Hyperlink___1___for_para_1) }</p>
            {/if}
            <div class="risk-profile-section-details">
                {#if riskProfile.URL_SVG && riskProfile.URL_SVG.indexOf('.svg') > -1}
                  <!-- Assumption: if not para2, all para shall not exists -->
                  <div class="bob {riskProfile.Risk_Profile___paragraph_2__wit ? '' : 'center'}">
                    <img alt="bob" src={`${riskProfile.URL_SVG.replace('flood-farhan', 'flood-ses')}`} />
                    <span class="bob-title">Person drawn to scale</span>
                  </div>
                {/if}
                <div class="bob-details" bind:this={bobDetailsElement}>
                  {#if riskProfile.Risk_Profile___paragraph_2__wit}
                    <p>{@html toTooltip(riskProfile.Risk_Profile___paragraph_2__wit, riskProfile.Hyperlink_2___for_para___2) }</p>
                  {/if}
                  <br/>
                  {#if riskProfile.Risk_profile___paragraph_3__wit}
                    <p>{@html toTooltip(riskProfile.Risk_profile___paragraph_3__wit, riskProfile.Hyperlink_3____for_para___3) }</p>
                  {/if}
                  <br/>
                  {#if riskProfile.Risk_Profile_paragraph_4____ind}
                    <p>{@html toTooltip(riskProfile.Risk_Profile_paragraph_4____ind, riskProfile.Hyperlink___1___for_para_1) }</p>
                  {/if}
                </div>
            </div>
          </div>
          {#if riskProfile.Postcode !== null && riskProfile.URL_PDF !== '' && !riskProfile.URL_PDF.includes('youtu.be')}
            <div class="risk-profile-cta">
              <a 
                target="_blank" 
                href={`${riskProfile.URL_PDF}`}
                bind:this={floodRiskProfileDownloadCta}>Download {capitalize(riskProfile.Suburb)} Flood Map</a>
              <p>Showing at 1 in 500 chance per year flood event.</p>
            </div>
          {/if}
        {/if}
    </div>
  {/if}
</div>


<script>
import tippy from "tippy.js";
import store, { STATES_START, STATES_MAIN } from "../../state";
import utils from "../../utils";
import { afterUpdate, onDestroy, onMount } from "svelte/internal";
//@ts-ignore
import RiskDetailsIcon from "../../assets/images/risk_details_icon.png";
import { slide } from "svelte/transition";
slide;
import { quintOut } from "svelte/easing";
quintOut;
import { fade } from "svelte/transition";
fade;
export let activeRegion = undefined;
// html vars
let riskProfile = undefined;
let riskDetailIcon = RiskDetailsIcon;
let capitalize = utils.capitalize;
let showProfile = false;
let showProfileCount = 0;
let floodRiskProfileMiniBar;
let floodRiskProfileDownloadCta;
let bobDetailsElement;
// script vars
let mapViewSvc;
let tippyInstance;
store.subscribe(state => {
    var _a;
    if (riskProfile && riskProfile.Suburb !== ((_a = state.riskProfile) === null || _a === void 0 ? void 0 : _a.Suburb)) {
        showProfileCount = 0;
    }
    if (state.currentState === `${STATES_MAIN.START}.${STATES_START.FLOOD_RISK}`) {
        showProfile = true;
        showProfileCount++;
    }
    else {
        showProfile = false;
    }
    riskProfile = state.riskProfile;
});
onMount(() => {
    if (activeRegion) {
        activeRegion.bind(floodRiskProfileMiniBar, "tap", () => {
            // Testing this mobile view in web browser will cause this to hit twice because
            // it detects cursor and pointer. In mobile its fine
            toggleRiskProfile();
        });
        activeRegion.bind(floodRiskProfileMiniBar, "swipe", (evt) => {
            const directionDegree = evt.detail.data[0].currentDirection;
            //For swipe up and down only
            // up 90deg, down 270deg, buffer +- 68 deg
            if (directionDegree >= 22 && directionDegree <= 157) {
                !showProfile && toggleRiskProfile();
            }
            if (directionDegree >= 202 && directionDegree <= 337) {
                showProfile && toggleRiskProfile();
            }
        });
    }
});
afterUpdate(() => {
    if (tippyInstance && tippyInstance.destroy) {
        tippyInstance.destroy();
    }
    tippyInstance = tippy("u", {
        size: "small",
        placement: "top",
        theme: "ses",
        arrow: !utils.isIE(),
        distance: 8,
        allowHTML: true,
        onMount(instance) {
            if (utils.isIE())
                return;
            const elementClientRect = instance.reference.getBoundingClientRect();
            const midpoint = elementClientRect.left + Math.ceil(elementClientRect.width / 2);
            let range = document.createRange();
            //@ts-ignore
            range.setStart(instance.reference.childNodes[0].childNodes[0], 0);
            //@ts-ignore
            range.setEnd(instance.reference.childNodes[0].childNodes[0], 1);
            const textFrontPosition = range.getClientRects()[0];
            const offSet = Math.ceil(textFrontPosition.x - midpoint);
            setTimeout(() => {
                let arrowElement = instance.popperChildren.arrow;
                if (arrowElement) {
                    if (offSet > -16)
                        arrowElement.style.transform = `translateX(${offSet + 16}px)`;
                    arrowElement.parentNode &&
                        arrowElement.parentNode.insertBefore(arrowElement.cloneNode(true), arrowElement);
                }
            });
        },
        onHidden(instance) {
            if (utils.isIE())
                return;
            let tooltipElement = instance.popperChildren.tooltip;
            tooltipElement.removeChild(tooltipElement.childNodes[0]);
        }
    });
});
onDestroy(() => {
    if (tippyInstance && tippyInstance.destroy) {
        tippyInstance.destroy();
    }
});
function toTooltip(haystack, strReplacements) {
    if (strReplacements === null)
        return haystack;
    const needle = new RegExp(/\*\*(.*?)\*\*/g);
    const replacements = strReplacements.split("|").map(s => s.trim());
    const matches = [];
    let match;
    while ((match = needle.exec(haystack)) != null) {
        matches.push(match[1]);
    }
    if (matches.length === replacements.length && matches.length > 0) {
        matches.forEach((m, i) => {
            const toReplace = `<u style="color:#5d86d8;cursor:pointer;" data-tippy-content="<div style='${utils.isIE() ? "" : "width:180px"}'>${replacements[i]}</div>"><em>${m}</em></u>`;
            haystack = haystack.replace(m, toReplace);
        });
    }
    return haystack.replace(/\*\*/g, "");
}
function toggleRiskProfile() {
    if (riskProfile && riskProfile.AOI === "IN") {
        if (!showProfile) {
            store.update(state => {
                state.currentState = `${STATES_MAIN.START}.${STATES_START.FLOOD_RISK}`;
                return state;
            });
            activeRegion && setDownloadRiskProfileTap();
        }
        else {
            activeRegion && setDownloadRiskProfileTap(true);
            store.update(state => {
                state.currentState = `${STATES_MAIN.START}.${STATES_START.DEFAULT}`;
                return state;
            });
        }
    }
}
function setDownloadRiskProfileTap(unbind) {
    if (unbind) {
        activeRegion.unbind(floodRiskProfileDownloadCta, "tap");
    }
    setTimeout(() => {
        activeRegion.bind(floodRiskProfileDownloadCta, "tap", () => {
            window.open(riskProfile === null || riskProfile === void 0 ? void 0 : riskProfile.URL_PDF, "_blank", "noopener");
        });
    });
}
</script>


<style>@-webkit-keyframes blinkingDot{0%{opacity:.6}to{opacity:1}}@keyframes blinkingDot{0%{opacity:.6}to{opacity:1}}@-webkit-keyframes arrowUp{0%{transform:translateY(8px);opacity:.6}to{transform:translateY(4px);opacity:1}}@keyframes arrowUp{0%{transform:translateY(8px);opacity:.6}to{transform:translateY(4px);opacity:1}}@-webkit-keyframes arrowDown{0%{transform:translateY(16px);opacity:.6}to{transform:translateY(12px);opacity:1}}@keyframes arrowDown{0%{transform:translateY(16px);opacity:.6}to{transform:translateY(12px);opacity:1}}.flood-risk-profile-blocker{position:absolute;z-index:1;width:100%;height:100%;background-color:rgba(17,17,17,.71);left:0;top:0}.flood-risk-profile{position:absolute;bottom:0;left:0;width:100%;z-index:4}.flood-risk-profile-mini-bar{height:48px;background:linear-gradient(180deg,#f4f4f4,#e8e8e8 19%,#999);color:#1d3b78;border-top:.1875rem solid #f08403;align-items:center;padding:0 16px;position:relative;z-index:1;font-size:.75rem;display:flex;transition:color .25s linear .35s}.flood-risk-profile-mini-bar p{position:relative}.flood-risk-profile-mini-bar:after{content:"";width:100%;position:absolute;background-color:#414141;opacity:0;z-index:-1;height:100%;top:0;left:0;transition:opacity .25s linear .35s}.flood-risk-profile-mini-bar.pointer{cursor:pointer}.flood-risk-profile-mini-bar .bold{font-family:AvenirLT-Heavy}.flood-risk-profile-mini-bar .new-flood-risk{content:"";position:absolute;width:8px;height:8px;border-radius:8px;background-color:#f08403;top:0;left:105%;-webkit-animation:blinkingDot .6s ease-in-out infinite alternate;animation:blinkingDot .6s ease-in-out infinite alternate}.flood-risk-profile-mini-bar .arrow-icons{position:relative;width:14.38px;height:28.76px;margin-right:14px;transition:transform .25s linear .3s;transform:rotate(0deg)}.flood-risk-profile-mini-bar .arrow-icons.reverse{transform:rotate(180deg)}.flood-risk-profile-mini-bar .arrow-icons img{position:absolute;width:auto}.flood-risk-profile-mini-bar .arrow-icons img:first-child{-webkit-animation:arrowUp .6s ease-in-out infinite alternate;animation:arrowUp .6s ease-in-out infinite alternate}.flood-risk-profile-mini-bar .arrow-icons img:last-child{-webkit-animation:arrowDown .6s ease-in-out infinite alternate;animation:arrowDown .6s ease-in-out infinite alternate}.flood-risk-profile-mini-bar.slide-up{color:#fff}.flood-risk-profile-mini-bar.slide-up:after{opacity:1}.flood-risk-profile-content{width:100%;height:calc(100vh - 88px);background-color:#fff;padding:18px;font-size:.85rem;position:relative}.flood-risk-profile-content .risk-profile-info p{font-size:.85rem;margin-bottom:1rem}.flood-risk-profile-content .risk-profile-info p:last-child{margin-bottom:0}.flood-risk-profile-content .risk-profile-section{min-height:50%;max-height:calc(100% - 109px);overflow-y:auto;font-family:AvenirLT-Roman}.flood-risk-profile-content .risk-profile-section p{line-height:20px}.flood-risk-profile-content .risk-profile-section-details{display:flex}.flood-risk-profile-content .risk-profile-section .first-para{margin-bottom:25px}.flood-risk-profile-content .risk-profile-section .bob{flex:0 0 auto;width:35%;margin:0 1.5625rem 0 0}.flood-risk-profile-content .risk-profile-section .bob.center{margin:0 auto}.flood-risk-profile-content .risk-profile-section .bob img[alt=bob]{height:auto}.flood-risk-profile-content .risk-profile-section .bob .bob-title{font-size:.6875rem;font-style:oblique;font-weight:500;line-height:15px}.flood-risk-profile-content .risk-profile-cta{position:absolute;bottom:0;left:0;height:109px;width:100%;background-color:#fff;box-shadow:0 2px 4px 0 rgba(0,0,0,.5);padding:26px 45px 24px;text-align:center}.flood-risk-profile-content .risk-profile-cta a{width:100%;background-color:#f08403;color:#fff;font-size:12px;line-height:16px;height:36px;border-radius:4px;text-decoration:none;display:block;padding:9.5px 0;font-family:AvenirLT-Heavy}.flood-risk-profile-content .risk-profile-cta a:active,.flood-risk-profile-content .risk-profile-cta a:focus,.flood-risk-profile-content .risk-profile-cta a:hover{color:#fff}.flood-risk-profile-content .risk-profile-cta p{margin-top:8px;font-size:11px;line-height:15px}@media screen and (max-width:767px){.flood-risk-profile{position:fixed}.flood-risk-profile-content{height:calc(100vh - 96px)}}</style>
